export enum ToastMessageTypeEnum {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}
